const CLOUDINARY_HOST = "https://res.cloudinary.com/";

export function isCloudinaryUrl(url?: string | null): boolean {
  return typeof url === "string" && url.startsWith(CLOUDINARY_HOST);
}

export function getOptimizedImageUrl(
  url?: string | null,
  transformations: string[] = []
): string {
  if (!url) return "";
  if (!isCloudinaryUrl(url)) return url;

  const sanitizedTransformations = transformations.filter(Boolean);
  const baseTransformations = ["f_auto", "q_auto", ...sanitizedTransformations].join(",");

  if (url.includes(`/upload/${baseTransformations}/`)) {
    return url;
  }

  return url.replace("/upload/", `/upload/${baseTransformations}/`);
}
